import { useQuery } from '@tanstack/react-query';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';

/**
 * Produkt-Statistik Lernplattform — Betreiber-Sicht, nur lesend. Aggregat über
 * Kurse, Einschreibungen, Abschlüsse, Lernende, Zertifikate und Sessions.
 * M2M-Auth wie alle /v1/admin/*-Endpoints.
 */
const FIXTURE = {
  courses: 37,
  enrollments: 5420,
  completed: 3188,
  learners: 2971,
  certificates: 2604,
  sessions: 41255,
};

export function useLearningStats() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['product-stats-learning', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return FIXTURE; }
      return nexusFetch('/v1/admin/product-stats/learning');
    },
    refetchInterval: 60_000,
  });
}
